import React from 'react';
import {TermsWrapper} from "../../screens/SearchListings/styles";
import {Empty, Space, Spin} from "antd";
import AlertMessage from "../AlertMessage";
import {StyledParagraph, StyledTitle} from "../CustomAntdComponents/Typography";

type Props = {
    loadingTermsData: boolean,
    termsError: string | null,
    terms: TermsAndConditions | null
}
const TermsAndConditionsContent = ({ loadingTermsData, terms, termsError }: Props) => {
    return (
         <TermsWrapper>
      <Spin spinning={loadingTermsData}>
        {termsError && <AlertMessage message={termsError} />}

        {!termsError && !loadingTermsData && !terms?.TC && (
          <Empty description="This flight does not have a fare rule" />
        )}

        {!termsError && !loadingTermsData && terms?.TC && (
          <div
            dangerouslySetInnerHTML={{ __html: terms.TC }}
          />
        )}
      </Spin>
    </TermsWrapper>
    );
};

export default TermsAndConditionsContent;
